import environment from '#/environment/environment';
import {tradingBotAddresses} from '#/utils/trading-bot-addresses';
import {isEqualLowerCase} from '@shareland/shareland-common';
import {Hex} from 'viem';

export const shouldWaitlistNetDisplayNullUserAssets = (account: Hex) =>
  environment.isWaitlistNet && !tradingBotAddresses.some(address => isEqualLowerCase(address, account));
